import React, { useEffect, useState } from "react";
import { useTranslations } from "../i18n/LanguageProvider";
import { PlayCircle } from "lucide-react";
import { Card } from "../components/ui/card";
import { Header } from "../components/ui/header";
import { Footer } from "../components/ui/footer";
import axios from "axios";
import { money } from "../utilities/currency";
import EventDetailPage from "./EventDetailPage.tsx";
import { useSelector } from 'react-redux';
import { RootState } from "../state/store.ts";
import Events from "../components/events.tsx";
type EventsPageProps = {
    currentUser: any,
    onLogout: any,
    baseUrl: string,
    onLoginClick: any,
    onLoginSuccess: any,
}
export default function EventsPage({ currentUser, onLogout, baseUrl, onLoginClick, onLoginSuccess }: EventsPageProps) {
  const T = useTranslations("home");
    const [selectedEvent, setSelectedEvent] = useState(null);

    const [wallet, setWallet] = useState(0);
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        if (currentUser?.role === "customer") {
            axios.get(baseUrl + "/getCustomerWallet", { params: { token: currentUser.token } })

                .then((response) => {
                    if (response.data.status === "OK") {
                        setWallet(response.data.data.remaining_amount);
                    }
                });
        }
    }, [currentUser, baseUrl])

    useEffect(() => {
        // Runs on page load
        const hash = window.location.hash.replace("#", "");

        if (hash) {
            // fetch event by ID
            axios.get(`${baseUrl}/getEventById`, { params: { id: hash } })
                .then(res => {
                    if (res.data.status === "OK") {
                        setSelectedEvent(res.data.data);
                    }
                });
        }
    }, []);

    const onBack = () => {
        setSelectedEvent(null);
    }

    // DETAIL VIEW
    if (selectedEvent) {
        return <EventDetailPage event={selectedEvent} onBack={onBack} currentUser={currentUser} baseUrl={baseUrl} onLoginSuccess={onLoginSuccess} />;
    }

    // LIST / GRID VIEW
    return (
        <div className={"bg-white text-gray-900"}>
            <Header wallet={wallet} scrolled={scrolled} T={T} onLoginClick={onLoginClick} currentUser={currentUser} onLogout={onLogout} baseUrl={baseUrl} />
            <Events currentUser={currentUser} onLogout={onLogout} baseUrl={baseUrl} onLoginClick={onLoginClick} onLoginSuccess={onLoginSuccess} selectedEvent={selectedEvent} setSelectedEvent={setSelectedEvent} />
            <Footer baseUrl={baseUrl} />
        </div>
    );
}
